import React from "react";

export default function ValueSelector({ value, onChange, disabled, values = [] }) {
  // Get competency count for selected value
  const selectedValueData = values.find(v => v.name === value);
  const competencyCount = selectedValueData?.competencies?.length || 0;

  return (
    <div className="value-selector">
      <label htmlFor="value-select" className="value-selector-label">
        Select a Value to Focus On
      </label>
      <div className="value-selector-wrapper">
        <select
          id="value-select"
          className="value-select"
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
        >
          <option value="">-- Select a Value --</option>
          {values.map((v) => (
            <option key={v.name} value={v.name}>
              {v.name} ({v.competencies?.length || 0} competencies)
            </option>
          ))}
        </select>
        <span className="value-select-caret"></span>
      </div>
      {value && (
        <p className="value-selector-hint">
          You will create a development entry for each of the {competencyCount} competencies under "{value}".
        </p>
      )}
    </div>
  );
}
